import { debounce } from "lodash";

import { ResponsiveBreakpoint } from "constants/responsive-breakpoint";
import { isBrowserSupportsPasiveEvents } from "helpers/check-browser-passive-support";

export class ResponsiveBreakpointsChecker {
  cachedInnerWidth: number;
  cachedInnerHeight: number;

  static $instance: ResponsiveBreakpointsChecker;

  static instance(): ResponsiveBreakpointsChecker {
    if (!ResponsiveBreakpointsChecker.$instance) {
      ResponsiveBreakpointsChecker.$instance = new ResponsiveBreakpointsChecker();
    }

    return ResponsiveBreakpointsChecker.$instance;
  }

  constructor() {
    this.cachedInnerWidth = window.innerWidth;
    this.cachedInnerHeight = window.innerHeight;
    window.addEventListener(
      "resize",
      this.throttledChangeCachedInnerDimensions,
      isBrowserSupportsPasiveEvents ? { passive: true } : false
    );
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  changeCachedInnerDimensions = () => {
    this.cachedInnerWidth = window.innerWidth;
    this.cachedInnerHeight = window.innerHeight;
  };

  throttledChangeCachedInnerDimensions = debounce(this.changeCachedInnerDimensions, 200);

  get windowWidth(): number {
    return this.cachedInnerWidth;
  }

  get windowHeight(): number {
    return this.cachedInnerHeight;
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  isMobileDeviceWidth = () => this.cachedInnerWidth <= ResponsiveBreakpoint.Mobile;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  isTabletDeviceWidth = () => this.cachedInnerWidth <= ResponsiveBreakpoint.Tablet;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  isDesktopDeviceWidth = () => this.cachedInnerWidth > ResponsiveBreakpoint.Tablet;
}
